import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.article<{ $isClickable: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(2)}`};

  border-radius: ${({ theme }) => theme.spacing(2)};
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  transition: background 200ms;

  color: ${({ theme }) => theme.palette.text.primary};

  &:hover {
    background: ${({ theme }) => theme.palette.grey[100]};
  }

  &:focus {
    outline: none;
    background: ${({ theme }) => theme.palette.grey[100]};
  }
`;

export const Title = styled.h1`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  flex: 1;

  padding: 0;
  margin: 0;

  cursor: inherit;
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LinkedItemContainer = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  max-width: 10rem;
`;

export const LinkedItemPrefixContainer = styled.span`
  font-size: 1.2rem;
  line-height: 62.5%;
`;

export const Dot = styled.span<{ $color: string }>`
  display: block;

  width: 0.6rem;
  height: 0.6rem;

  border-radius: 50%;
  background: ${({ $color, theme }) => schemeColor($color, theme)};
`;

export const EndedLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  flex-shrink: 0;

  color: ${({ theme }) => theme.palette.error.main};

  white-space: nowrap;
`;

export const LinkedItemTitle = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  color: ${({ theme }) => theme.palette.text.secondary};

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;
